import {
  useDeleteLeadTime,
  useListLeadTime,
} from "hooks/lead-times/useLeadTime";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import React, { useEffect, useState, useMemo } from "react";
import {
  Button,
  Modal,
  Table,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from "reactstrap";
import {
  useDeleteLocation,
  useListLocation,
  useTransports,
  useTypeOrder,
  useUpdateLocation,
} from "../../../hooks";
import CustomerLeadTimeForm from "./CustomerLeadTimeForm";
import CustomerLocationForm from "./CustomerLocationForm";
import { CustomerLocationType } from "./utils";

const CustomerLocationTable = ({
  customerId,
  type = CustomerLocationType.RECEIVE,
  ...props
}) => {
  const {
    isFetching,
    data: locations,
    refetch: fetchLocationsByCustomer,
    remove: resetLocationsByCustomer,
  } = useListLocation({
    params: {
      "filter[customer_id][eq]": customerId,
      "filter[location_type][eq]": type,
      sort: "-checker_date",
      page: -1,
      expand: "transport,groupName,hub_name",
      // expand: "transport",
    },
  });

  const {
    isFetching: isLoadingLeadTime,
    data: listLeadTime,
    refetch: fetchLeadTime,
    remove: resetListLeadTime,
  } = useListLeadTime({
    params: {
      "filter[customer_id][eq]": customerId,
      sort: "-checker_date",
      page: -1,
      expand: "transport,typeName",
    },
  });

  const {
    refetch: onFetchTransports,
    isFetching: isLoadingTransports,
    data: listTransport,
  } = useTransports({
    params: {
      "filter[record_status]": "O",
      page: -1,
    },
  });

  const {
    refetch: onFetchOrderTypes,
    isFetching: isLoadingOrderTypes,
    data: listOrderType,
  } = useTypeOrder();

  useEffect(() => {
    if (type === CustomerLocationType.LEAD_TIMES) {
      fetchLeadTime();
      onFetchTransports();
      onFetchOrderTypes();
    } else {
      fetchLocationsByCustomer();
    }
  }, [customerId, type]);
  const { t, i18n } = useTranslation(["customer"]);
  const isTypeReturn = () => {
    return type == CustomerLocationType.RETURN_RESULT;
  };
  // Location
  const [currentUpdatingLocation, setCurrentUpdatingLocation] = useState({});
  const openModalUpdate = location => {
    if (location.is_new_address && location.is_new_address == "N") {
      location.is_level_2 = true;
    } else {
      location.is_level_2 = false;
    }
    location.group_code = location?.groupName
      ?.split(", ")
      .map((value, index) => ({
        value: location.group_code[index],
        label: value,
      }));
    setCurrentUpdatingLocation(location);
    setIsModalUpdateOpen(true);
  };

  const onDeleteSuccess = data => {
    fetchLocationsByCustomer();
  };
  const { mutate: deleteLocation } = useDeleteLocation(onDeleteSuccess);

  const { mutate: updateLocation } = useUpdateLocation(() => {
    fetchLocationsByCustomer();
  });
  const onToggleShowInOrder = (location, isChecked) => {
    updateLocation({
      id: location.id,
      data: {
        is_show_in_order: isChecked ? "Y" : "N",
        checker_date: isChecked ? Date.now() : null,
      },
    });
  };
  const openDelete = idLocation => {
    deleteLocation({ id: idLocation });
  };

  const [isModalUpdateOpen, setIsModalUpdateOpen] = useState(false);
  const [isModalCreateOpen, setIsModalCreateOpen] = useState(false);
  const onCreateLocation = location => {
    fetchLocationsByCustomer();
    setIsModalCreateOpen(false);
  };
  const onUpdateLocation = location => {
    fetchLocationsByCustomer();
    setIsModalUpdateOpen(false);
  };
  // Leadtime
  const [currentUpdatingLeadTime, setCurrentUpdatingLeadTime] = useState({});
  const openModalUpdateLeadTime = leadTime => {
    setCurrentUpdatingLeadTime(leadTime);
    setIsModalLeadTimeUpdateOpen(true);
  };

  const onDeleteLeadTimeSuccess = data => {
    fetchLeadTime();
  };
  const { mutate: deleteLeadTime } = useDeleteLeadTime(onDeleteLeadTimeSuccess);
  const openDeleteLeadTime = idLeadTime => {
    deleteLeadTime({ id: idLeadTime });
  };

  const [isModalLeadTimeUpdateOpen, setIsModalLeadTimeUpdateOpen] =
    useState(false);
  const [isModalLeadTimeCreateOpen, setIsModalLeadTimeCreateOpen] =
    useState(false);
  const onCreateLeadTime = leadTime => {
    fetchLeadTime();
    setIsModalLeadTimeCreateOpen(false);
  };
  const onUpdateLeadTime = leadTime => {
    fetchLeadTime();
    setIsModalLeadTimeUpdateOpen(false);
  };
  //

  const [addressLevelFilter, setAddressLevelFilter] = useState({
    value: "all",
    label: "Tất cả",
  });

  const [isOpenAddrFilter, setIsOpenAddrFilter] = useState(false);

  // Filter options
  const addressLevelFilterOptions = [
    { value: "all", label: "Tất cả" },
    { value: "2", label: "2 cấp" },
    { value: "3", label: "3 cấp" },
  ];

  const handleAddressLevelFilterChange = selectedOption => {
    setAddressLevelFilter(selectedOption);
  };

  const filteredLocations = useMemo(() => {
    if (!locations?.items) {
      return [];
    }

    let filtered = locations.items;

    if (addressLevelFilter.value !== "all") {
      filtered = locations.items.filter(location => {
        const isLevel2 =
          location.is_new_address === "N" ||
          location.from_hub_is_new_address === "N" ||
          location.to_hub_is_new_address === "N" ||
          !location.district_code ||
          location.is_level_2 === true;

        return addressLevelFilter.value === "2" ? isLevel2 : !isLevel2;
      });
    }

    return filtered.sort((a, b) => {
      const aIsChecked = a.is_show_in_order === "Y";
      const bIsChecked = b.is_show_in_order === "Y";

      if (aIsChecked && !bIsChecked) return -1;
      if (!aIsChecked && bIsChecked) return 1;

      const aDate = a.checker_date ? new Date(a.checker_date) : new Date(0);
      const bDate = b.checker_date ? new Date(b.checker_date) : new Date(0);

      return bDate - aDate;
    });
  }, [locations?.items, addressLevelFilter]);

  const filterTable = (value, indexTd, idTable = "table-location") => {
    var filter, table, tr, td, i, txtValue;
    filter = value.toUpperCase();
    table = document.getElementById(`${idTable}-${type}`);
    if (table) {
      tr = table.getElementsByTagName("tr");
      for (i = 0; i < tr.length; i++) {
        td = tr[i].getElementsByTagName("td")[indexTd];
        if (td) {
          txtValue = td.textContent || td.innerText;
          if (txtValue.toUpperCase().indexOf(filter) > -1) {
            tr[i].style.display = "";
          } else {
            tr[i].style.display = "none";
          }
        }
      }
    }
  };

  const getAddressLevel = location => {
    const isLevel2 =
      location.is_new_address === "N" ||
      location.from_hub_is_new_address === "N" ||
      location.to_hub_is_new_address === "N" ||
      !location.district_code ||
      location.is_level_2 === true;

    return isLevel2 ? "2 cấp" : "3 cấp";
  };

  return (
    <div>
      {/* START Location form modal */}
      <Modal
        isOpen={isModalUpdateOpen}
        centered
        toggle={() => {
          setIsModalUpdateOpen(!isModalUpdateOpen);
        }}
      >
        <CustomerLocationForm
          type={type}
          location={currentUpdatingLocation}
          handleCancel={() => setIsModalUpdateOpen(false)}
          onSuccess={onUpdateLocation}
        />
      </Modal>
      <Modal
        isOpen={isModalCreateOpen}
        centered
        toggle={() => {
          setIsModalCreateOpen(!isModalCreateOpen);
        }}
      >
        <CustomerLocationForm
          customerId={customerId}
          type={type}
          handleCancel={() => setIsModalCreateOpen(false)}
          onSuccess={onCreateLocation}
        />
      </Modal>
      {/* END Location form modal */}
      {/* START Leadtime form modal */}
      <Modal
        isOpen={isModalLeadTimeUpdateOpen}
        centered
        toggle={() => {
          setIsModalLeadTimeUpdateOpen(!isModalLeadTimeUpdateOpen);
        }}
      >
        <CustomerLeadTimeForm
          type={type}
          leadTime={currentUpdatingLeadTime}
          listTransport={
            listTransport?.items?.map(item => ({
              value: item.id,
              label: item.name,
            })) || []
          }
          listOrderType={listOrderType || []}
          handleCancel={() => setIsModalLeadTimeUpdateOpen(false)}
          onSuccess={onUpdateLeadTime}
        />
      </Modal>
      <Modal
        isOpen={isModalLeadTimeCreateOpen}
        centered
        toggle={() => {
          setIsModalLeadTimeCreateOpen(!isModalLeadTimeCreateOpen);
        }}
      >
        <CustomerLeadTimeForm
          customerId={customerId}
          listTransport={
            listTransport?.items?.map(item => ({
              value: item.id,
              label: item.name,
            })) || []
          }
          listOrderType={listOrderType || []}
          type={type}
          handleCancel={() => setIsModalLeadTimeCreateOpen(false)}
          onSuccess={onCreateLeadTime}
        />
      </Modal>
      {/* END Leadtime form modal */}

      <div className="mb-3 d-flex align-items-center gap-3">
        <Button
          className="btn"
          color="primary"
          disabled={isFetching || isLoadingLeadTime}
          onClick={() => {
            if (type === CustomerLocationType.LEAD_TIMES) {
              setIsModalLeadTimeCreateOpen(true);
            } else {
              setIsModalCreateOpen(true);
            }
          }}
        >
          Thêm
        </Button>

        {type !== CustomerLocationType.LEAD_TIMES && (
          <div style={{ minWidth: 100 }}>
            <Dropdown
              isOpen={isOpenAddrFilter}
              toggle={() => setIsOpenAddrFilter(!isOpenAddrFilter)}
            >
              <DropdownToggle
                className="btn primary-btn w-100 text-overflow"
                caret
              >
                Địa chỉ
                <span>:&nbsp;{addressLevelFilter.label}</span>
                <i className="mdi mdi-chevron-down" />
              </DropdownToggle>
              <DropdownMenu className="w-100" style={{ minWidth: 100 }}>
                {addressLevelFilterOptions.map(opt => (
                  <DropdownItem
                    key={opt.value}
                    onClick={() => handleAddressLevelFilterChange(opt)}
                  >
                    {opt.label}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          </div>
        )}
      </div>

      {type === CustomerLocationType.LEAD_TIMES ? (
        isLoadingLeadTime ? (
          <>Đang tải ...</>
        ) : (
          <div className="custom-table">
            <Table bordered hover responsive id={`table-leadtime-${type}`}>
              <thead style={{ verticalAlign: "top" }}>
                <tr>
                  <th style={{ width: "20px" }}>{t("form.contact_count")}</th>
                  <th className="d-flex" style={{ flexDirection: "column" }}>
                    {t("form.lead_time.transporter_id")}
                    <div style={{ width: "150px" }}>
                      <Select
                        placeholder={t("placeholder.select")}
                        options={
                          listTransport?.items?.map(item => ({
                            value: item.id,
                            label: item.name,
                          })) || []
                        }
                        isClearable
                        onChange={e => {
                          filterTable(e?.label || "", 1, "table-leadtime");
                        }}
                        isSearchable
                        className="basic-single w-100"
                      />
                    </div>
                  </th>
                  <th style={{ width: "161px" }}>
                    {t("form.lead_time.forwarded_time")}
                  </th>
                  <th style={{ width: "161px" }}>
                    {t("form.lead_time.delivered_time")}
                  </th>
                  <th style={{ width: "161px" }}>
                    {t("form.lead_time.collected_time")}
                  </th>
                  <th style={{ width: "161px" }}>
                    {t("form.lead_time.completed_time")}
                  </th>
                  <th style={{ width: "161px" }}>
                    {t("form.lead_time.type")}
                    <div style={{ width: "150px" }}>
                      <Select
                        placeholder={t("placeholder.select")}
                        options={listOrderType || []}
                        isClearable
                        onChange={e => {
                          filterTable(e?.label || "", 6, "table-leadtime");
                        }}
                        isSearchable
                        className="basic-single w-100"
                      />
                    </div>
                  </th>
                  <th style={{ width: "110px" }}></th>
                </tr>
              </thead>
              <tbody>
                {listLeadTime?.items?.length > 0 &&
                  listLeadTime.items.map((leadTime, index) => {
                    return (
                      <tr key={leadTime.id}>
                        <td>{index + 1}</td>
                        <td>{leadTime?.transport?.name}</td>
                        <td>{leadTime.forwarded_time}</td>
                        <td>{leadTime.delivered_time}</td>
                        <td>{leadTime.collected_time}</td>
                        <td>{leadTime.completed_time}</td>
                        <td>{leadTime.typeName}</td>
                        <td>
                          <div
                            className="btn btn-link"
                            onClick={() => openModalUpdateLeadTime(leadTime)}
                          >
                            <i className="fas fa-pen fa-lg text-primary"></i>
                          </div>
                          <div
                            className="btn btn-link"
                            onClick={() => openDeleteLeadTime(leadTime.id)}
                          >
                            <i className="fas fa-trash fa-lg text-danger"></i>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </Table>
          </div>
        )
      ) : isFetching ? (
        <>Đang tải ...</>
      ) : (
        <div className="custom-table">
          <Table bordered hover responsive id={`table-location-${type}`}>
            <thead style={{ verticalAlign: "top" }}>
              <tr>
                <th style={{ width: "20px" }}>{t("form.contact_count")}</th>

                {type === CustomerLocationType.RECEIVE && (
                  <th
                    style={{
                      minWidth: "140px",
                      textAlign: "center",
                    }}
                  >
                    Hiển thị khi tạo đơn
                  </th>
                )}
                {type !== CustomerLocationType.LEAD_TIMES &&
                  addressLevelFilter.value === "all" && (
                    <th
                      style={{
                        minWidth: "100px",
                        textAlign: "center",
                      }}
                    >
                      Loại địa chỉ
                    </th>
                  )}
                {isTypeReturn() ? (
                  <>
                    <th>
                      Code
                      <input
                        type="search"
                        style={{
                          width: "200px",
                        }}
                        onChange={e => {
                          filterTable(e.target?.value, 1);
                        }}
                        placeholder={`Nhập Code`}
                      ></input>
                    </th>
                    <th>Địa chỉ mặc định</th>
                    <th>Nhóm</th>
                    <th>
                      Địa chỉ quy đổi
                      <input
                        type="search"
                        style={{
                          width: "120px",
                        }}
                        onChange={e => {
                          filterTable(e.target?.value, 4);
                        }}
                        placeholder={`Nhập địa chỉ quy đổi`}
                      ></input>
                    </th>
                    <th>
                      {t("form.transport")}
                      <input
                        type="search"
                        style={{
                          width: "200px",
                        }}
                        onChange={e => {
                          filterTable(e.target?.value, 5);
                        }}
                        placeholder={`Nhập ${t("form.transport")}`}
                      ></input>
                    </th>
                    <th>
                      {t("form.hub")}
                      <input
                        type="search"
                        style={{
                          width: "200px",
                        }}
                        onChange={e => {
                          console.log("e.target.value", e.target?.value);
                          filterTable(e.target?.value, 6);
                        }}
                        placeholder={`Nhập ${t("form.hub")}`}
                      ></input>
                    </th>
                  </>
                ) : (
                  <></>
                )}

                <th className="d-flex" style={{ flexDirection: "column" }}>
                  {t("form.contact_address")}
                  <input
                    type="search"
                    style={{
                      width: "200px",
                    }}
                    onChange={e => {
                      filterTable(e.target?.value, !isTypeReturn() ? 1 : 7);
                    }}
                    placeholder={`Nhập ${t("form.contact_address")}`}
                  ></input>
                </th>
                <th style={{ width: "161px" }}>
                  {t("form.contact_name")}
                  <input
                    type="search"
                    style={{
                      width: "200px",
                    }}
                    onChange={e => {
                      filterTable(e.target?.value, !isTypeReturn() ? 2 : 8);
                    }}
                    placeholder={`Nhập ${t("form.contact_name")}`}
                  ></input>
                </th>
                <th style={{ width: "161px" }}>
                  {t("form.contact_phone")}
                  <input
                    type="search"
                    style={{
                      width: "200px",
                    }}
                    onChange={e => {
                      filterTable(e.target?.value, !isTypeReturn() ? 3 : 9);
                    }}
                    placeholder={`Nhập ${t("form.contact_phone")}`}
                  ></input>
                </th>
                {(type === CustomerLocationType.RECEIVE ||
                  type === CustomerLocationType.RETURN_RESULT) && (
                  <th style={{ minWidth: "100px" }}>
                    {t("table.client_hub_id")}
                  </th>
                )}
                <th style={{ width: "110px" }}></th>
              </tr>
            </thead>
            <tbody>
              {filteredLocations?.length > 0 &&
                filteredLocations.map((location, index) => {
                  return (
                    <tr key={location.id}>
                      <td>{index + 1}</td>
                      {type === CustomerLocationType.RECEIVE && (
                        <td style={{ textAlign: "center" }}>
                          <input
                            type="checkbox"
                            checked={location?.is_show_in_order === "Y"}
                            onChange={e =>
                              onToggleShowInOrder(location, e.target.checked)
                            }
                          />
                        </td>
                      )}
                      {type !== CustomerLocationType.LEAD_TIMES &&
                        addressLevelFilter.value === "all" && (
                          <td style={{ textAlign: "center" }}>
                            <span
                              className={`badge ${
                                getAddressLevel(location) === "2 cấp"
                                  ? "bg-info"
                                  : "bg-secondary"
                              }`}
                              style={{
                                fontSize: "11px",
                                padding: "4px 8px",
                              }}
                            >
                              {getAddressLevel(location)}
                            </span>
                          </td>
                        )}
                      {isTypeReturn() ? (
                        <>
                          <td>{location.code}</td>
                          <td>
                            <div
                              className="text-primary text-center fw-bold"
                              style={{ width: "120px" }}
                            >
                              {location.is_default ? (
                                <i
                                  style={{ fontSize: "26px" }}
                                  className={`bx bx-check-circle text-success`}
                                ></i>
                              ) : (
                                ""
                              )}
                            </div>
                          </td>
                          <td className="">
                            {location?.groupName
                              ?.split(", ")
                              .map((item, index) => {
                                return (
                                  <span
                                    className="group-name-location"
                                    style={{
                                      background: "#1890ff",
                                      padding: "2px 7px",
                                      fontWeight: "bold",
                                      color: "white",
                                      borderRadius: "9px",
                                      marginRight: "2px",
                                    }}
                                    key={index}
                                  >
                                    {item}
                                  </span>
                                );
                              })}
                          </td>
                          <td>{location.mapping_code}</td>
                          <td>{location.transport?.name}</td>
                          <td>{location.hub_name}</td>
                        </>
                      ) : (
                        <></>
                      )}
                      <td>{location.fullAddress}</td>
                      <td>{location.contact_name}</td>
                      <td>{location.contact_phone}</td>
                      {(type === CustomerLocationType.RECEIVE ||
                        type === CustomerLocationType.RETURN_RESULT) && (
                        <td>{location.client_hub_id}</td>
                      )}
                      <td>
                        <div
                          className="btn btn-link"
                          onClick={() => openModalUpdate(location)}
                        >
                          <i className="fas fa-pen fa-lg text-primary"></i>
                        </div>
                        <div
                          className="btn btn-link"
                          onClick={() => openDelete(location.id)}
                        >
                          <i className="fas fa-trash fa-lg text-danger"></i>
                        </div>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
        </div>
      )}
    </div>
  );
};

export default CustomerLocationTable;
